import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { motion } from 'framer-motion';
import { Excelente } from '../../../../svg/Excelente';
import { Bueno } from '../../../../svg/Bueno';
import { Regular } from '../../../../svg/Regular';
import { Malo } from '../../../../svg/Malo';
import { Pesimo } from '../../../../svg/Pesimo';

export const SatisfactionResponse = (props) => {

    const { action, options } = props;
    const classes = useStyles();

    return (
        <Grid container justifyContent='center' alignItems='center' gap={2}>
            {
                options?.map(o => (
                    <Grid key={o} item xs={ 1.6 } sm={ 1.5 } md={ 1.3 } lg={ 1 }>
                        <motion.div
                            whileHover={{ scale: 1.2 }}
                            whileTap={{ scale: 1 }}
                            onClick={ () => action(Number(o)) }
                        >
                            { o === String(1) && <Pesimo className={ classes.svg } /> }
                            { o === String(2) && <Malo className={ classes.svg } /> }
                            { o === String(3) && <Regular className={ classes.svg } /> }
                            { o === String(4) && <Bueno className={ classes.svg } /> }
                            { o === String(5) && <Excelente className={ classes.svg } /> }
                        </motion.div>
                    </Grid>
                ))
            }
        </Grid>
    )
}

const useStyles = makeStyles({
    svg: {
        '&:hover': {
            cursor: 'pointer'
        }
    }
});